import React from "react";

const usePresentationFullscreen = () => {
  const [isFullscreen, setIsFullscreen] = React.useState(false);

  const enterFullscreen = React.useCallback(() => setIsFullscreen(true), []);
  const exitFullscreen = React.useCallback(() => setIsFullscreen(false), []);

  return {isFullscreen, setIsFullscreen, enterFullscreen, exitFullscreen};
};

export default usePresentationFullscreen;
